module.exports = __webpack_public_path__ + "static/img/no_vendor.c3c60b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_vendor.png
// module id = Gfx7
// module chunks = 0